import { ModalControls } from "../../../../customHooks/useModalControl";
import { ContributionsBulkApprovalsResponse } from "../../../../redux/features/approvals/approvals.type";
import { SingleBulkContributionLog } from "../../../../redux/features/contributions/contributions.type";
import { ApprovalActionDetails } from "../../../../utils/types";
import { TimeText } from "../../../typography/timeText";
import { TableComponent } from "../../table";

export const BulkContributionsApproval = ({
  modalControls,
  approvals,
  setActionDetails,
  setSelectedBulkEntry,
  fetching,
}: {
  modalControls: ModalControls;
  approvals?: ContributionsBulkApprovalsResponse;
  setActionDetails: (v: ApprovalActionDetails) => void;
  setSelectedBulkEntry: (v: SingleBulkContributionLog) => void;
  fetching: boolean;
}) => {
  const { handleModalOpen } = modalControls;

  return (
    <>
      <TableComponent
        mobileCardView
        headers={["File name", "Date Uploaded", "Uploaded by"]}
        headerActionProps={{
          hasActions: true,
          hasCheckbox: false,
          checked: false,
          onCheck: () => {},
          onUncheck: () => {},
          hasMoreMenu: true,
        }}
        rows={
          approvals?.data?.map((entry, idx) => {
            return {
              id: entry.id,
              onClick: () => {},
              items: [
                <p className="max-md:max-w-[200px] text-ellipsis overflow-hidden max-w-full">
                  {entry.filename ?? "N/A"}
                </p>,
                <TimeText
                  timeString={entry.DateAdded}
                  key={`entry-${entry.id}-date-${idx}`}
                />,
                <p>
                  {entry?.MemberIDWhoUpload?.User?.FirstName}{" "}
                  {entry?.MemberIDWhoUpload?.User?.LastName}
                </p>,
              ],
              actionProps: {
                hasActions: true,
                hasCheckbox: false,
                hasMoreMenu: true,
                moreOptions: [
                  {
                    icon: "view",
                    text: "View Entries",
                    onClick: () => {
                      setSelectedBulkEntry(entry);

                      handleModalOpen("viewSingleBultEntriesModal");
                    },
                  },
                  {
                    icon: "verified-icon",
                    text: "Accept",
                    onClick: () => {
                      setSelectedBulkEntry(entry);

                      setActionDetails({
                        type: "single",
                        isApprove: true,
                        singleId: entry.id,
                      });

                      handleModalOpen("confirmationModal");
                    },
                  },
                  {
                    icon: "close-icon",
                    text: "Decline",
                    onClick: () => {
                      setSelectedBulkEntry(entry);

                      setActionDetails({
                        type: "single",
                        isApprove: false,
                        singleId: entry.id,
                      });

                      handleModalOpen("confirmationModal");
                    },
                  },
                ],
              },
            };
          }) ?? []
        }
        stickyLastCol
        isRowClickable={false}
        onRowClick={() => {}}
        isTableEmpty={[0, undefined].includes(approvals?.data?.length)}
        emptyTitle="No Pending Approvals"
        isLoading={fetching}
        isPaginated={false}
      />
    </>
  );
};
